var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtilityCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.615 0.0948583C11.7614 0.176355 11.8763 0.304539 11.9413 0.458962C12.0064 0.613385 12.0179 0.785151 11.974 0.946858L9.98195 8.24986H17.25C17.3961 8.24987 17.5391 8.29258 17.6613 8.37276C17.7835 8.45293 17.8796 8.56706 17.9378 8.70113C17.9961 8.8352 18.0138 8.98336 17.989 9.12739C17.9641 9.27142 17.8977 9.40505 17.798 9.51186L7.29795 20.7619C7.18359 20.8847 7.03135 20.9656 6.86558 20.9916C6.69981 21.0177 6.53009 20.9874 6.38357 20.9056C6.23704 20.8238 6.12218 20.6952 6.05735 20.5405C5.99252 20.3857 5.98146 20.2137 6.02595 20.0519L8.01795 12.7499H0.749953C0.603792 12.7498 0.460818 12.7071 0.338607 12.627C0.216397 12.5468 0.120276 12.4327 0.0620594 12.2986C0.00384316 12.1645 -0.0139308 12.0164 0.0109226 11.8723C0.035776 11.7283 0.102173 11.5947 0.201953 11.4879L10.702 0.237858C10.8163 0.115504 10.9683 0.0349508 11.1338 0.00903472C11.2993 -0.0168814 11.4687 0.0133314 11.615 0.0948583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilityCard);
export default __webpack_public_path__ + "static/media/utility_card.568a5d29c070510c9e832a0f9d779d06.svg";
export { ForwardRef as ReactComponent };